import "./RegisterHeader.css";

function RegisterHeader() {

  return (

    <div className="register-header">

      <div className="logo-circle">

        🍽

      </div>

      <h1>HomeFoods</h1>

      <p>

        Fresh Homemade Food,<br/>

        Delivered with Love ❤️

      </p>

      <h2>Create Customer Account</h2>

    </div>

  );

}

export default RegisterHeader;